/**
 * Transversal model used to synchronize data across the application
 */
export var TransversalSyncModel = Backbone.Model.extend({

});